import { useCallback, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const toProgress = (data) => ({ completed: data.completed, total: data.total, pct: data.progress_pct });

export default function useSkills(section) {
  const [members, setMembers] = useState([]);
  const [awards, setAwards] = useState({});
  const [expanded, setExpanded] = useState(null);
  const [skillsData, setSkillsData] = useState(null);
  const [progress, setProgress] = useState({});

  const load = useCallback(async () => {
    const [m, a] = await Promise.all([api.get("/members", { params: { section } }), api.get("/awards")]);
    setMembers(m.data);
    setAwards(a.data);
    const entries = await Promise.all(m.data.map(async (mem) => {
      try {
        const { data } = await api.get(`/skills/${mem.id}`);
        return [mem.id, toProgress(data)];
      } catch (err) {
        return [mem.id, null];
      }
    }));
    setProgress(Object.fromEntries(entries));
  }, [section]);

  useEffect(() => {
    setExpanded(null);
    setSkillsData(null);
    load().catch(() => toast.error("Could not load skills"));
  }, [load]);

  const toggleExpand = async (memberId) => {
    if (expanded === memberId) { setExpanded(null); return; }
    setExpanded(memberId);
    const { data } = await api.get(`/skills/${memberId}`);
    setSkillsData(data);
  };

  const toggleSkill = async (skill, achieved) => {
    try {
      await api.post(`/skills/${expanded}`, { skill, achieved: !achieved });
      const { data } = await api.get(`/skills/${expanded}`);
      setSkillsData(data);
      setProgress((prev) => ({ ...prev, [expanded]: toProgress(data) }));
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  return { members, awards, expanded, skillsData, progress, toggleExpand, toggleSkill };
}
